(function () {
  function initQuiz(root) {
    var dialog = root.querySelector('[data-quiz-dialog]');
    var openButton = root.querySelector('[data-quiz-open]');
    var closeButton = root.querySelector('[data-quiz-close]');
    var backButton = root.querySelector('[data-quiz-back]');
    var restartButton = root.querySelector('[data-quiz-restart]');
    var form = root.querySelector('[data-quiz-form]');
    var result = root.querySelector('[data-quiz-result]');
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-quiz-step]'));
    var stepNumber = root.querySelector('[data-quiz-step-number]');
    var productData = JSON.parse(root.querySelector('[data-quiz-products]').textContent);
    var current = 0;
    var lastFocused;

    function setStep(index) {
      current = index;
      steps.forEach(function (step, i) { step.hidden = i !== current; });
      stepNumber.textContent = String(current + 1).padStart(2, '0');
      backButton.hidden = current === 0;
      var first = steps[current].querySelector('input');
      if (first) window.setTimeout(function () { first.focus(); }, 80);
    }

    function open() {
      lastFocused = document.activeElement;
      current = 0;
      form.hidden = false;
      result.hidden = true;
      form.reset();
      setStep(0);
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      document.documentElement.classList.add('quiz-is-open');
    }

    function close() {
      if (typeof dialog.close === 'function' && dialog.open) dialog.close();
      else dialog.removeAttribute('open');
      document.documentElement.classList.remove('quiz-is-open');
      if (lastFocused) lastFocused.focus();
    }

    function showResult() {
      var answers = Array.prototype.slice.call(form.querySelectorAll('input[type="radio"]:checked'));
      var scores = answers.reduce(function (totals, answer) {
        totals[answer.value] = (totals[answer.value] || 0) + 1;
        return totals;
      }, {});
      var ranked = Object.keys(scores).sort(function (a, b) { return scores[b] - scores[a]; });
      var highestScore = scores[ranked[0]] || 0;
      var tied = ranked.filter(function (handle) { return scores[handle] === highestScore; });
      /* For a tie, prefer the latest answer: scent first, then place, time and element. */
      var preferenceOrder = answers.slice().reverse().map(function (answer) { return answer.value; });
      tied.sort(function (a, b) { return preferenceOrder.indexOf(a) - preferenceOrder.indexOf(b); });
      var winner = tied[0] || 'neer-vata';
      var alternateHandle = tied.length > 1 ? tied[1] : null;
      var product = productData[winner];
      var resultLabel = root.querySelector('[data-quiz-result-label]');
      var primaryLabel = root.querySelector('[data-quiz-primary-label]');
      root.querySelector('[data-quiz-result-name]').textContent = product.name;
      root.querySelector('[data-quiz-result-story]').textContent = product.story;
      var image = root.querySelector('[data-quiz-result-image]');
      image.src = product.image;
      image.alt = product.name + ' perfume';
      root.querySelector('[data-quiz-result-link]').href = product.url;
      var alternate = root.querySelector('[data-quiz-alternate]');
      if (alternateHandle) {
        var alternateProduct = productData[alternateHandle];
        var alternateImage = alternate.querySelector('[data-quiz-alternate-image]');
        alternateImage.src = alternateProduct.image;
        alternateImage.alt = alternateProduct.name + ' perfume';
        alternate.querySelector('[data-quiz-alternate-name]').textContent = alternateProduct.name;
        alternate.querySelector('[data-quiz-alternate-link]').href = alternateProduct.url;
        resultLabel.textContent = 'Your fragrance pairing';
        primaryLabel.hidden = false;
        alternate.hidden = false;
        result.classList.add('is-tied');
      } else {
        resultLabel.textContent = 'Your AVYU fragrance';
        primaryLabel.hidden = true;
        alternate.hidden = true;
        result.classList.remove('is-tied');
      }
      form.hidden = true;
      result.hidden = false;
      result.querySelector('[data-quiz-result-name]').focus();
    }

    openButton.addEventListener('click', open);
    closeButton.addEventListener('click', close);
    dialog.addEventListener('click', function (event) { if (event.target === dialog) close(); });
    backButton.addEventListener('click', function () { if (current > 0) setStep(current - 1); });
    restartButton.addEventListener('click', function () { form.hidden = false; result.hidden = true; form.reset(); setStep(0); });
    form.addEventListener('change', function (event) {
      if (!event.target.matches('input[type="radio"]')) return;
      if (current < steps.length - 1) window.setTimeout(function () { setStep(current + 1); }, 220);
      else window.setTimeout(showResult, 220);
    });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && (dialog.open || dialog.hasAttribute('open'))) close(); });
  }

  document.querySelectorAll('[data-fragrance-quiz]').forEach(initQuiz);
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-quiz-open]');
    if (!trigger || trigger.closest('[data-fragrance-quiz]')) return;
    var quizTrigger = document.querySelector('[data-fragrance-quiz] [data-quiz-open]');
    if (quizTrigger) quizTrigger.click();
  });
}());
